import MedicalDisposalList from '../MedicalDisposalList.vue'
import RecipientStatistics from '../RecipientStatistics.vue'
import MedicalInstitutionsStatistics from '../MedicalInstitutionsStatistics.vue'
import MedicalDisposalDataExport from '../MedicalDisposalDataExport.vue'
import MedicalDataEdit from '../MedicalDataEdit.vue'
/**
 *数据路由
 */
const query = [
    {
        name: '医废处置列表',
        path: '/medicalDisposal/MedicalDisposalList',
        component: MedicalDisposalList
    },
    {
        name: '按接收人统计医废',
        path: '/medicalDisposal/RecipientStatistics',
        component: RecipientStatistics
    },
    {
        name: '按医疗机构统计医废',
        path: '/medicalDisposal/MedicalInstitutionsStatistics',
        component: MedicalInstitutionsStatistics
    },
    {
        name: '医废处置统计导出',
        path: '/medicalDisposal/MedicalDisposalDataExport',
        component: MedicalDisposalDataExport
    },
    {
        name:'修改医废数据',
        path:'/medicalDisposal/MedicalDataEdit',
        component:MedicalDataEdit
    }
];
export default query
